<template>
  <section class="route-view-box">
    <div class="route-view-box-left">
      <CategoriesMenu />
    </div>
    <div class="route-view-box-right">
      <router-view :key="$route.fullPath" />
    </div>
  </section>
</template>

<script>
import { get_api_data } from "@/utils/ajax";
import { mapMutations, mapState } from "vuex";
import CategoriesMenu from "./CategoriesMenu.vue";
import categoryCache from "@/utils/categoryCache";

export default {
  name: "route-view-box",
  components: {
    CategoriesMenu,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("global", ["churchLifeModel"]),
  },
  created() {
    // 监听全局导航守卫
    this.$router.beforeEach((to, from, next) => {
      // 搜索页面由搜索框逻辑专门驱动，避免全库请求并发打架
      if (to.name !== "search") {
        this.get_image_card_list(to);
      }
      if (to.params.categories === "0AChSkKAoqzZMUk9PVA") {
        this.updateChurchLifeModel(0);
      }
      next();
    });

    // 当重复点击相同类别时加载数据（此时 route 未发生变化）
    this.$P.$on("clickCategoryUpdateImgList", () => {
      this.get_image_card_list(this.$route);
      // 取消二级标签高亮
      $(".tag-list button").removeClass("active");
    });
  },
  methods: {
    ...mapMutations("global", [
      "updateDriveIdsID",
      "updateLv1_ID",
      "updateAllCardList",
      "updateAllCardListMeta",
      "updateChurchLifeModel",
      "updateIsListLoading",
    ]),

    /**
     * 判断当前路由是否与目标请求路由一致，避免慢速网络请求乱序覆盖新页面
     */
    isCurrentRouteMatch(targetRoute) {
      const currentCat = this.$route.params.categories || "";
      const currentMat = this.$route.params.materialList || "";
      const targetCat = targetRoute.params ? (targetRoute.params.categories || "") : "";
      const targetMat = targetRoute.params ? (targetRoute.params.materialList || "") : "";
      return currentCat === targetCat && currentMat === targetMat;
    },

    /**
     * SWR 极致秒开：优先读取内存缓存 0ms 直出渲染，随后在后台静默发起轻量比对校验
     */
    async get_image_card_list(routeTo) {
      this.GLOBAL.scrollPage = 1;
      try {
        window.scrollTo({ top: 0, behavior: "instant" });
      } catch (e) {
        window.scrollTo(0, 0);
      }

      const isHome = routeTo.name === "home" || routeTo.path === "/" || !routeTo.params.categories;
      const isDriveOnly = Boolean(routeTo.params.categories && !routeTo.params.materialList);
      const driveIds = isHome ? [] : [routeTo.params.categories];
      const lv1_categories = (isHome || isDriveOnly) ? [] : [routeTo.params.materialList];
      
      this.updateDriveIdsID(driveIds);
      this.updateLv1_ID(lv1_categories);

      const queryParams = {
        driveIds,
        lv1_categories,
        lv2_categories: [],
        type: "all",
        size: "all",
        start: "",
        end: "",
        keyword: "",
        scenes: this.churchLifeModel || 0,
        inc_tag: "include",
        orderby: "created_at",
        order: "desc",
        per_page: 80,
        page: 1,
      };

      // 1. 尝试从 SWR 内存缓存池中读取
      const cached = categoryCache.get(queryParams);
      if (cached && Array.isArray(cached.data)) {
        // 【缓存命中：0ms 瞬时秒显，跳过骨架屏】
        this.updateAllCardList(cached.data);
        this.updateAllCardListMeta(cached.meta);
        this.updateIsListLoading(false);

        // 后台静默发起校验，若有更新则平滑替更，绝不打扰用户当前浏览
        categoryCache.revalidate(queryParams, (freshData, freshMeta) => {
          if (this.isCurrentRouteMatch(routeTo)) {
            this.updateAllCardList(freshData);
            this.updateAllCardListMeta(freshMeta);
          }
        });
        return;
      }

      // 2. 【未命中缓存：首次访问或无预取数据】规范呈现流光骨架屏
      this.updateIsListLoading(true);
      this.updateAllCardListMeta({ total: null });
      this.updateAllCardList([]);

      try {
        const cardInfo = await get_api_data("GET", "search", queryParams);

        if (cardInfo && cardInfo.data && Array.isArray(cardInfo.data.data)) {
          // 写入缓存池供下次与返回时 0ms 秒开
          categoryCache.set(queryParams, cardInfo.data.data, cardInfo.data.meta);

          if (this.isCurrentRouteMatch(routeTo)) {
            this.updateAllCardList(cardInfo.data.data);
            this.updateAllCardListMeta(cardInfo.data.meta);
          }
        }
      } catch (err) {
        console.error("加载分类数据异常:", err);
      } finally {
        if (this.isCurrentRouteMatch(routeTo)) {
          this.updateIsListLoading(false);
        }
      }
    },
  },
};
</script>

<style>
</style>
